import React, { Component, Fragment } from 'react';
import { Header, Segment, Grid, Form, Checkbox } from 'semantic-ui-react';

import { SearchInputBox, Authority } from 'components/Commons';

import storage from 'helpers/storage';
import cm from 'helpers/commons';
import DormantStaffList from './DormantStaffList';

const propTypes = {};

const defaultProps = {};

class DormantStaffArea extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const { param, tabType, staffCheckedData, userCnt, isLoadingBar } = this.props.data;
    const {
      param: nparam,
      tabType: ntabType,
      staffCheckedData: nstaffCheckedData,
      userCnt: nuserCnt,
      isLoadingBar: nisLoadingBar
    } = nextProps.data;
    const changeParams = param !== nparam; // true면 render
    const changeTabType = tabType !== ntabType; // true면 render
    const changeCheckedData = staffCheckedData !== nstaffCheckedData; // true면 render;
    const changeUserCnt = userCnt !== nuserCnt; // true면 render;
    const changeLoadingBar = isLoadingBar !== nisLoadingBar;
    return changeParams || changeTabType || changeCheckedData || changeUserCnt || changeLoadingBar;
  }

  render() {
    const { fn, data } = this.props;

    const {
      param: { dormantTargetFilter }
    } = data || { param: {} };
    const comid = ((storage.get('company') || {}).info || {}).id;
    const navi = '전체';
    const options = [
      { value: null, text: '권한 전체' },
      { value: 'USER', text: '일반사용자' },
      { value: 'COM_ADMIN', text: '회사관리자' }
    ];
    if (comid === 'B068366F-5EB8-1C7E-E79C-D438C8E32F9D') {
      options.push({ value: 'SUPER', text: '전체 관리자' });
    }
    return (
      <Fragment>
        <Header className="staff-header" attached="top" block style={{ width: '100%' }}>
          전체
        </Header>
        <Segment attached>
          <Grid className="search-box">
            <Grid.Column floated="left" width={2} style={{ marginRight: 0 }}>
              <span>
                {data.staffCheckedData.length}명 / {data.userCnt}명
              </span>
            </Grid.Column>
            <Grid.Column floated="right" width={10} className="">
              <Form style={{ float: 'right' }}>
                <Form.Group>
                  <Authority options={options} fnOnChange={fn.handleSubmit} />
                  <SearchInputBox
                    handleSubmit={fn.handleSubmit}
                    handleEntSubmit={fn.handleEntSubmit}
                    styles={{ width: 250 }}
                    placeHolder="id, 이름, 이메일, 휴대전화번호"
                  />
                </Form.Group>
              </Form>
            </Grid.Column>
          </Grid>
          <DormantStaffList
            params={data.param}
            staffCheckedData={data.staffCheckedData}
            // isLoadingBar={data.isLoadingBar}
            staffSel={fn.staffSel}
            staffChecked={fn.staffChecked}
            isLoadingBarChange={fn.isLoadingBarChange}
          />
        </Segment>
      </Fragment>
    );
  }
}

DormantStaffArea.propTypes = propTypes;
DormantStaffArea.defaultProps = defaultProps;

export default DormantStaffArea;
